import { IntegrationApp } from '@src/types/integrations';
import type { Selector } from '@types';

// eslint-disable-next-line import/prefer-default-export
export const integrationAppsSelector: Selector<IntegrationApp[]> = state =>
  state.integrationApps.apps;
